<ng-container *ngIf="!isLoading">

  <!-- Buttons -->
  <div style="text-align:center; margin-bottom:10px">
    <button class="noPrint" mat-raised-button color="primary" (click)="printPage()">
      Print
    </button>

    <button class="noPrint" style="margin-left:10px" (click)="exportExcel('Representativewise_Sadhyasthiti_Report')" mat-raised-button color="primary">
      Export
    </button>

    <button mat-dialog-close class="btn noPrint" style="margin-left:10px">
      Close
    </button>
  </div>


  <!-- PRINT SECTION -->
  <div id="print-section">

    <table style=" table-layout: fixed !important; font-size:14px;">

      <!-- MAIN HEADER -->
      <thead>

        <tr>
          <th colspan="7"
              style="border:2px solid black; text-align:center; font-size:18px; padding:6px;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
          </th>
        </tr>

        <tr>
          <th colspan="7" style="border-left:2px solid black; border-right:2px solid black; border-bottom:2px solid black; text-align:right; padding:4px;">
            दिनांक :- {{ endDate | date:"dd/MM/yyyy" }}
          </th>
        </tr>

        <tr>
          <th colspan="7" style="border:2px solid black; text-align:center; font-size:16px; padding:6px;">
            प्रतिनिधीनिहाय सद्यस्थिती
          </th>
        </tr>

        <!-- COLUMN HEADER -->
        <tr style="border:2px solid black;">
          <th style="border:1px solid black; ">अनुक्रमांक</th>
          <th style="border:1px solid black; ">प्रतिनिधी निहाय</th>
          <th style="border:1px solid black; ">पोस्ट</th>
          <th style="border:1px solid black; ">हस्ते</th>
          <th style="border:1px solid black; ">मॅगझीन</th>
          <th style="border:1px solid black; ">डिजिटल</th>
          <th style="border:1px solid black; ">एकूण</th>
        </tr>

      </thead>


      <!-- BODY -->
    <tbody>
    
        <tr *ngFor="let rep of representativeData; let i=index">
    
            <td colspan="1" style="border:1px solid black; text-align:center; border-left:2px solid black;">
                {{ i+1 }}
            </td>
    
            <td colspan="1" style="border:1px solid black; ">
                {{ rep.repName }} - {{rep.rep_taluka}}
            </td>
    
            <td colspan="1" style="border:1px solid black; text-align:right;">
                {{ rep.post }}
            </td>
    
            <td colspan="1" style="border:1px solid black; text-align:right;">
                {{ rep.haste }}
            </td>
    
            <td colspan="1" style="border:1px solid black; text-align:right;">
                {{ rep.magazine }}
            </td>
    
            <td colspan="1" style="border:1px solid black; text-align:right;">
                {{ rep.digital }}
            </td>
    
            <td colspan="1" style="border:1px solid black; text-align:right; border-right:2px solid black;">
                {{ rep.total }}
            </td>
    
        </tr>
    
    
        <!-- GRAND TOTAL -->
        <tr style="font-weight:bold;">
            <td colspan="2" style="border:2px solid black; width: 100px; text-align:  center; border-left:2px solid black;">
                एकूण :-
            </td>
    
            <td style="border:2px solid black; text-align:right;">
                {{ totalPostTotal }}
            </td>
    
            <td style="border:2px solid black; text-align:right;">
                {{ totalHasteTotal }}
            </td>
    
            <td style="border:2px solid black; text-align:right;">
                {{ totalMagzineTotal }}
            </td>
    
            <td style="border:2px solid black; text-align:right;">
                {{ totalDigitalTotal }}
            </td>
    
            <td style="border:2px solid black; text-align:right; border-right:2px solid black;">
                {{ grandTotal }}
            </td>
    
        </tr>
    
    </tbody>

    </table>
  </div>

</ng-container>


<!-- LOADER -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>
